import React from 'react';
import ReactDOM from 'react-dom';
import './ConfirmModal.css';

interface ConfirmModalProps {
    title: string;
    eventName: string;
    message: string;
    confirmLabel: string;
    variant: 'warning' | 'danger';
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    title,
    eventName,
    message,
    confirmLabel,
    variant,
    onConfirm,
    onCancel,
}) => {
    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) onCancel();
    };

    return ReactDOM.createPortal(
        <div className="confirm-modal-backdrop" onClick={handleBackdropClick} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
            <div className="confirm-modal">
                <h2 id="confirm-modal-title" className="confirm-modal-title">{title}</h2>
                <p className="confirm-modal-message">
                    <span className="confirm-modal-event-name">"{eventName}"</span>
                    {' '}{message}
                </p>
                <div className="confirm-modal-actions">
                    <button className="confirm-modal-cancel" onClick={onCancel}>Cancel</button>
                    <button
                        className={`confirm-modal-confirm confirm-modal-confirm--${variant}`}
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmModal;
